import {userInfo,getUserProduct} from "@/api/auth/auth-api"
import jwt from "@/common/jwt"

const userStore = {
    namespace: true,
    state: {
        isAuthenticated: false,
        userInfo: {},
        studentInfo: {},
        productInfo : {}
    },

    getters: {
        userInfo(state) {
            return {
                'isAuthenticated': state.isAuthenticated,
                'info': state.userInfo
            }
        },
        isAuthenticated(state) {
            return state.isAuthenticated;
        },
        getStudentInfo(state) {
            return state.studentInfo;
        },
        getProductInfo(state) {
            return state.productInfo
        }
    },
    mutations: {
        updateUserInfo(state, result) {
            state.isAuthenticated = result.data.parentId !== null ? true : false;
            state.userInfo = result.data.parentId ? result.data : {};
        },
        loggedOut(state) {
            state.isAuthenticated = false;
            state.userInfo = {};
            state.productInfo = {}
        },
        updateStudentInfo(state, result) {
            state.studentInfo = result;
        },
        setUserProduct(state, result) {
            state.productInfo = result;
        }
    },
    actions: {
        async loadProductInfo({commit },studentId) {
            const params = {
                'student_id' : studentId
            }
            const res = await getUserProduct(params);
            if (res) {
                const studyIdx = res.data.data.userProducts.findIndex(item => item.name === 'study'),
                      readingIdx = res.data.data.userProducts.findIndex(item => item.name === 'superReading'),
                      readingEngIdx = res.data.data.userProducts.findIndex(item => item.name === 'superReadingEng');
                const result = {
                    'study_yn' : studyIdx > -1 ? 'Y' : 'N',
                    'study_div' : studyIdx === -1 ? 'N' : (res.data.data.userProducts[studyIdx].level === 'trial') ? 'F' : 'C',
                    'reading_yn' : readingIdx > -1 ? 'Y' : 'N',
                    'reading_div' : readingIdx === -1 ? 'N' : (res.data.data.userProducts[readingIdx].level === 'trial') ? 'F' : 'C',
                    'readingEng_yn' : readingEngIdx > -1 ? 'Y' : 'N',
                    'readingEng_div' : readingEngIdx === -1 ? 'N' : (res.data.data.userProducts[readingEngIdx].level === 'trial') ? 'F' : 'C',
                }
                 commit('setUserProduct', result);
                return true;
            } else {
                return false;
            }
        },
        loadUserInfo: ({commit}) => {
            if(jwt.getToken()) {
                userInfo().then((res) => {
                    const result = res.data;
                    if (result.code === '200') {
                        commit('updateUserInfo', result);
                    }
                }).catch(() => {
                    jwt.destroyAll();
                    if (!(window.location.href.indexOf("/login") > -1)) {
                        document.location.href = "/#/login";
                    }
                });
            }else{
                jwt.destroyAll();
                if (!(window.location.href.indexOf("/login") > -1)) {
                    document.location.href = "/#/login";
                }
            }
        }
    }
}

export default userStore